import { mapApiImageToImageProps } from './common.mappers';

import type { FGuideTemplateProps } from '@/components/templates/FGuideTemplate.vue';

export function mapApiDataToGuide(
  guideRawData: StrapiResponseData<GuideContentType>[] | undefined
): FGuideTemplateProps | null {
  const guideDataAttributes = guideRawData?.[0]?.attributes;
  if (!guideDataAttributes) return null;

  return {
    title: guideDataAttributes.title,
    slug: guideDataAttributes.slug,
    excerpt: guideDataAttributes.excerpt,
    description: guideDataAttributes.description,
    hubspotFormUrl: guideDataAttributes.hubspot_form_url,
    chapters: guideDataAttributes.chapters,
    reinsuranceCards: guideDataAttributes.value_props,
    hubspotFormId: guideDataAttributes.hubspot_form_id,
    pdfUrl: guideDataAttributes.pdf_url,
    image: mapApiImageToImageProps(
      guideDataAttributes?.image?.data?.attributes,
      'medium'
    ),
    audience: guideDataAttributes.audience?.data?.attributes.name ?? '',
    guideStage: guideDataAttributes.guide_stage?.data?.attributes.name ?? '',
    topics: (guideDataAttributes.topics?.data || []).map(
      topic => topic?.attributes.name
    ),
  };
}
